import PropTypes from 'prop-types';
import React from 'react';

import { CardCell } from 'modules/journey/card/styled';

import StopRowStyled from '../styled';

import {
  AddressCompanyNameCell,
  AddressLabelCell,
  StopCommentsCell,
  StopHandlingCell,
  StopIconCell,
  StopNumberOfItemsCell,
  StopTimesCell,
  StopWeightCell,
} from 'modules/journey/card/cells';

const UnassignedStopRow = ({
  skin,
  isPartiallyCancelled,
  className,
  journeyId,
  stopId,
  showLoadInfo,
  store,
  isAggregated,
}) => {
  return (
    <StopRowStyled
      className={className}
      skin={skin}
      lightCell={isPartiallyCancelled}
      store={store}
      isAggregated={isAggregated}
    >
      <CardCell cellWidth={'344, 290, 192'} cellOverflow cellColor="grey700" mRight="S,XS">
        <AddressCompanyNameCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell mRight="XS,XS" cellWidth={'297, 195, 180'} cellOverflow cellColor="grey700">
        <AddressLabelCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellWidth={'16,16,16'}>
        {showLoadInfo && <StopIconCell journeyId={journeyId} stopId={stopId} />}
      </CardCell>
      <CardCell
        cellWidth={'40,40,40'}
        mRight="S,XS"
        alignRight
        cellColor="grey700"
        fontWeight="normal"
      >
        {showLoadInfo && <StopNumberOfItemsCell journeyId={journeyId} stopId={stopId} />}
      </CardCell>
      <CardCell
        cellWidth={'62,62,62'}
        mRight="XXL,XS"
        alignRight
        cellColor="grey700"
        fontWeight="normal"
      >
        {showLoadInfo && <StopWeightCell journeyId={journeyId} stopId={stopId} />}
      </CardCell>
      <CardCell cellWidth={'100,150,145'} />
      <CardCell cellWidth={16} mRight="XS">
        <StopCommentsCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellWidth={16}>
        <StopHandlingCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellPush />
      <CardCell cellWidth={88} alignRight boldText cellColor="grey700">
        <StopTimesCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
    </StopRowStyled>
  );
};

UnassignedStopRow.propTypes = {
  skin: PropTypes.string.isRequired,
  className: PropTypes.string,
  journeyId: PropTypes.number.isRequired,
  stopId: PropTypes.number.isRequired,
  isPartiallyCancelled: PropTypes.bool,
  showLoadInfo: PropTypes.bool,
};

UnassignedStopRow.defaultProps = {
  className: undefined,
};

export default UnassignedStopRow;
